var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-form" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "destroy-on-close": "",
            width: "1000px",
            "custom-class": "custom-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _vm.step != 1
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: _vm.formLoading },
                          on: { click: _vm.submitForm },
                        },
                        [_vm._v("保 存")]
                      )
                    : _vm._e(),
                  _vm.formType != "update" && _vm.step != 2
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: _vm.formLoading },
                          on: { click: _vm.nextStep },
                        },
                        [_vm._v(" 下一步 ")]
                      )
                    : _vm._e(),
                  _vm.formType != "update" && _vm.step != 1
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: _vm.formLoading },
                          on: {
                            click: function () {
                              return (_vm.step = 1)
                            },
                          },
                        },
                        [_vm._v(" 上一步 ")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step === 1,
                  expression: "step === 1",
                },
              ],
            },
            [
              _c("div", { staticClass: "step-title" }, [
                _vm._v("选择特殊监控商品"),
              ]),
              _c(
                "el-form",
                {
                  ref: "queryFormRef",
                  attrs: {
                    model: _vm.tableFrom,
                    size: "small",
                    inline: "",
                    "label-width": "80px",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品信息：", prop: "keywords" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入商品ID 或 名称",
                          size: "small",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.keywords,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "keywords",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.keywords",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品分类：", prop: "categoryId" } },
                    [
                      _c("el-cascader", {
                        ref: "cascader",
                        attrs: {
                          clearable: "",
                          options: _vm.merPlatProductClassify,
                          props: _vm.categoryProps,
                          size: "small",
                        },
                        model: {
                          value: _vm.tableFrom.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "categoryId", $$v)
                          },
                          expression: "tableFrom.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品品牌：", prop: "brandName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入商品品牌",
                          size: "small",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.brandName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "brandName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.brandName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户名称：", prop: "merId" } },
                    [
                      _c("merchantName", {
                        attrs: { merIdChecked: _vm.tableFrom.merId },
                        on: { getMerId: _vm.getMerId },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSearchList },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.resetSearchForm },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "multipleTable",
                  attrs: {
                    data: _vm.tableData.data,
                    size: "small",
                    "highlight-current-row": "",
                    "row-key": _vm.getRowKey,
                    stripe: "",
                    height: "40vh",
                  },
                  on: {
                    "select-all": _vm.handleSelectAllChange,
                    select: _vm.handleSelect,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      type: "index",
                      width: "50",
                      index: function (index) {
                        return (
                          (_vm.tableFrom.page - 1) * _vm.tableFrom.limit +
                          index +
                          1
                        )
                      },
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "商品ID", width: "100" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "商品名称",
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "specName",
                      label: "规格名称",
                      "min-width": "100",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      label: "商品分类",
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brandName",
                      label: "商品品牌",
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "merchantName",
                      label: "商户",
                      "min-width": "160",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c(
                    "template",
                    { slot: "empty" },
                    [_c("el-empty", { attrs: { description: "暂无数据~" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "page-sizes": [10, 20, 40, 60, 80],
                      "page-size": _vm.tableFrom.limit,
                      "current-page": _vm.tableFrom.page,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.tableData.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step === 2,
                  expression: "step === 2",
                },
              ],
            },
            [
              _vm.formType != "update"
                ? _c("div", { staticClass: "step-title" }, [
                    _vm._v("设置商品监控规则"),
                  ])
                : _vm._e(),
              _vm.formType != "create" && _vm.rulesForm.productImage
                ? _c(
                    "div",
                    { staticClass: "ml40 mb20 goods-info" },
                    [
                      _c("el-image", {
                        staticClass: "goods-img",
                        attrs: {
                          src: _vm.rulesForm.productImage,
                          "preview-src-list": [_vm.rulesForm.productImage],
                        },
                      }),
                      _c("div", { staticClass: "info-content ml20" }, [
                        _c("div", { staticClass: "info-title" }, [
                          _vm._v("("),
                          _c("span", { staticClass: "text-highlight" }, [
                            _vm._v(_vm._s(_vm.rulesForm.productId)),
                          ]),
                          _vm._v(") " + _vm._s(_vm.rulesForm.productName)),
                        ]),
                        _c("div", { staticClass: "info-text mt15" }, [
                          _vm._v(_vm._s(_vm.rulesForm.specName)),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.rulesForm,
                    rules: _vm.rules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "监控频率：",
                                prop: "monitorRateId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择监控频率" },
                                  model: {
                                    value: _vm.rulesForm.monitorRateId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "monitorRateId",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.monitorRateId",
                                  },
                                },
                                _vm._l(
                                  _vm.monitorRateIdOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("span", { staticClass: "tips-text" }, [
                          _vm._v(
                            "设置系统检查价格变动的频率，高频监控可能影响系统性能"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "对比平台：", prop: "platformIds" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.rulesForm.platformIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.rulesForm, "platformIds", $$v)
                            },
                            expression: "rulesForm.platformIds",
                          },
                        },
                        _vm._l(_vm.platformIdsOptions, function (item, index) {
                          return _c(
                            "el-checkbox",
                            { key: index, attrs: { label: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "tips-label",
                        attrs: { slot: "label" },
                        slot: "label",
                      },
                      [_vm._v("设置预警阈值：")]
                    ),
                    _c("span", { staticClass: "tips-text" }, [
                      _vm._v(
                        "上涨预警阈值比例、下降预警阈值比例、上涨预警阈值、下降预警阈值四个值至少填1个，监控的商品只要一个涨跌超过阈值就预警。"
                      ),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "上涨预警阈值(比例)：",
                                prop: "raiseWarnRatio",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入",
                                    oninput:
                                      "value=value.replace(/[^\\d\\.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.rulesForm.raiseWarnRatio,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "raiseWarnRatio",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.raiseWarnRatio",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [_vm._v("%")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "下降预警阈值(比例)：",
                                prop: "decreaseWarnRatio",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入",
                                    oninput:
                                      "value=value.replace(/[^\\d\\.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.rulesForm.decreaseWarnRatio,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "decreaseWarnRatio",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.decreaseWarnRatio",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [_vm._v("%")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "上涨预警阈值(固定值)：",
                                prop: "raiseWarnFix",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入",
                                    oninput:
                                      "value=value.replace(/[^\\d\\.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.rulesForm.raiseWarnFix,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "raiseWarnFix",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.raiseWarnFix",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [_vm._v("元")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "下降预警阈值(固定值)：",
                                prop: "decreaseWarnFix",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: "请输入",
                                    oninput:
                                      "value=value.replace(/[^\\d\\.]/g,'')",
                                  },
                                  model: {
                                    value: _vm.rulesForm.decreaseWarnFix,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "decreaseWarnFix",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.decreaseWarnFix",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "suffix" },
                                      slot: "suffix",
                                    },
                                    [_vm._v("元")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "特殊监控规则：",
                                prop: "specialRuleIds",
                              },
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.rulesForm.specialRuleIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rulesForm,
                                        "specialRuleIds",
                                        $$v
                                      )
                                    },
                                    expression: "rulesForm.specialRuleIds",
                                  },
                                },
                                _vm._l(
                                  _vm.specialRuleIdsOptions,
                                  function (item, index) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: index,
                                        attrs: { label: item.value },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }